import { DisabledRequiredRule, RequiredRule } from "capitalrx-components-2.0/lib/forms/validation/rules/required";

import { REQUIRED_ERROR } from "./constants";


export function required(required: boolean): RequiredRule {
  return required? {
    required: {
      value: true,
      message: REQUIRED_ERROR,
    },
  }: DisabledRequiredRule;
};
